var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCargoLogoFull = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141 38",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8fc02b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0v38h38V0H0ZM23.25,30.6l-13.26-11.53v-.02s0,0,0,0v-3.12h14.76v-5.38h-14.76v-3.12h17.88v11.62h-13.14l13.28,11.54h-4.76Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.07,24.9v-10.7c0-3.01,1.55-4.52,4.64-4.52h8.22l1.51,1.14v1.49h-9.7c-1.12,0-1.69.53-1.69,1.6v11.27c0,1.07.56,1.6,1.69,1.6h9.7v1.49l-1.51,1.14h-8.22c-3.1,0-4.64-1.51-4.64-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.48,28.82l6.54-19.14h4.76l6.51,19.14-.38.6h-2.51l-1.54-4.69h-8.9l-1.57,4.69h-2.48l-.41-.6ZM69.8,22.1h7.19l-3.28-9.78h-.62l-3.28,9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.45,29.42V9.69h9.73c3.09,0,4.64,1.51,4.64,4.52v3.18c0,2.44-1.03,3.87-3.1,4.29l3.7,7.09-.35.66h-2.54l-3.96-7.55h-5.12v7.55h-2.99ZM88.43,19.24h6.71c1.12,0,1.69-.54,1.69-1.63v-3.69c0-1.07-.56-1.6-1.69-1.6h-6.71v6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.14,24.9v-10.7c0-3.01,1.55-4.52,4.64-4.52h8.81l1.51,1.14v1.49h-10.29c-1.12,0-1.69.53-1.69,1.6v11.27c0,1.07.56,1.6,1.69,1.6h7.9v-6.35h-4.7v-2.63h7.69v11.61h-10.91c-3.1,0-4.64-1.51-4.64-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.01,24.9v-10.7c0-3.01,1.55-4.52,4.64-4.52h6.86c3.1,0,4.64,1.51,4.64,4.52v10.7c0,3.01-1.55,4.52-4.64,4.52h-6.86c-3.1,0-4.64-1.51-4.64-4.52ZM127,25.19c0,1.07.56,1.6,1.69,1.6h6.8c1.12,0,1.69-.53,1.69-1.6v-11.27c0-1.07-.56-1.6-1.69-1.6h-6.8c-1.12,0-1.69.53-1.69,1.6v11.27Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCargoLogoFull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cargo_logo_full.dd6e5d3bed7c248f228074d32a014b60.svg";